<template>
  <div class="container-balance">
    <div>
      <CollapsePanel style="padding: 0;" v-model="showChart">
        <span slot="title"><span class="rectangle" style="background: #f09537;"></span>箱量日分布</span>
        <span slot="port">
          <div class="port-form" v-if="showChart">
            <div class="port-checkbox">
              <CheckboxGroup v-model="portIdList" class="checkbox">
                <span class="form-label">港口</span>
                <Checkbox
                  v-for="item in portList"
                  :key="item.portId"
                  :label="item.portId"
                  >{{ item.portName }}</Checkbox
                >
              </CheckboxGroup>
            </div>
          </div>
        </span>
        <span slot="time">
          <div class="dateRange-select" v-if="showChart">
            <span>时间</span>
            <Select
              v-model="dateRange"
              style="width: 100px; margin-left: 10px;"
              size="small"
            >
              <Option
                v-for="item in dateRangeList"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </div>
        </span>
        <!-- <div class="legend" v-if="isFourWeekRange && portIdList.length < 2"> -->
        <div class="legend" v-if=" portIdList.length < 2" style="display: flex;">
          <div class="legend-item">
            <span
              class="color-area"
              :style="{ backgroundColor: chartColorTheme[0] }"
            ></span>
            <span class="legend-title">淡时</span>
          </div>
          <div class="legend-item">
            <span
              class="color-area"
              :style="{ backgroundColor: chartColorTheme[1] }"
            ></span>
            <span class="legend-title">旺时</span>
          </div>
          <div class="legend-item">
            <span
              class="color-area"
              :style="{ backgroundColor: chartColorTheme[2] }"
            ></span>
            <span class="legend-title">平均日箱量</span>
          </div>
          <div v-if="containerBalanceResDto && (containerBalanceResDto.portId === 'SHANGHAI' || containerBalanceResDto.portId === 'NINGBO')" class="legend-item" style="margin: 10px 130px 0 auto;">
            箱平衡:
            <span :class="[
                  (containerBalanceResDto.customerCoefficient - containerBalanceResDto.standardCoefficient) >= 0
                    ? 'text-green'
                    : 'text-red',
                ]">
              {{containerBalanceResDto.customerCoefficient}}
            </span>
          </div>
        </div>
        <div class="chart-box">
          <div id="container-balance-chart" ref="chartEle"></div>
          <span></span>
        </div>
      </CollapsePanel>
      <div></div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import CollapsePanel from "@/components/place-order/collapse-panel"
import echarts from "@moon-land/echarts/lib/echarts"
import "@moon-land/echarts/lib/chart/bar"
import "@moon-land/echarts/lib/chart/line"
import "@moon-land/echarts/lib/component/grid"
import "@moon-land/echarts/lib/component/dataZoom"
import "@moon-land/echarts/lib/component/markLine"
import "@moon-land/echarts/lib/component/tooltip"
import dayjs from "dayjs"
import _ from "lodash"

import {
  fetchContainerHistory,
  fetchContainerPortAndNum,
  changeTime,
} from "@/api/containerBalance"

let chartInstance = null
const WEEK_DAY = {
  "0": "周日",
  "1": "周一",
  "2": "周二",
  "3": "周三",
  "4": "周四",
  "5": "周五",
  "6": "周六",
}

const maxWith = window.innerWidth
function chartDisplayPercent() {
  if (maxWith >= 1500) {
    return 100
  } else if (maxWith >= 1200) {
    return 80
  } else if (maxWith >= 1000) {
    return 65
  }

  return 100
}

window.onresize = () => {
  chartInstance && chartInstance.resize()
}

const COLOR_THEME = ["#3fb1e3", "#f00", "#FF9003"]
export default {
  components: {
    CollapsePanel,
  },
  props: {
    defaultPortIds: {
      default() {
        return []
      },
    },
    portOptionList: {
      default() {
        return []
      },
    },
  },
  created() {},
  data() {
    return {
      containerBalanceResDto: {},
      showChart: true,
      portList: [],
      portIdList: [],
      loading: false,
      isCollapsed: false,
      dateRange: "CYCLE_TIME_FOUR_WEEKS",
      dateRangeList: [
        {
          value: "CYCLE_TIME_FOUR_WEEKS",
          label: "最近四周",
        },
        {
          value: "CYCLE_TIME_THREE_MONTHES",
          label: "最近三个月",
        },
        {
          value: "CYCLE_TIME_SIX_MONTHES",
          label: "最近六个月",
        },
      ],
      chartColorTheme: COLOR_THEME,
    }
  },
  methods: {
    async renderChart(payload = {}) {
      const chartEle = this.$refs.chartEle
      const width = document.getElementsByClassName("collapse-panel")[0]
        .clientWidth
      chartInstance = echarts.init(chartEle, null, {
        height: 360,
        width,
      })

      this.loading = true
      const resp = await fetchContainerHistory({
        ...payload,
        portIds: [...new Set(this.portIdList)],
      })
      this.loading = false
      this.containerBalanceResDto = resp.containerBalanceResDto 
      const { averageNum, dayContainerStatisticsDto,dayQtyLimit='-1' } = resp
      averageNum ? this.showChart = true : this.showChart =false
      const today = dayjs().format("YYYY-MM-DD")
      const todayWeekDay = dayjs().day()
      // 处理数据 使之符合表格
      let data = dayContainerStatisticsDto.map((v) => ({
        date: v.planArrivalDate,
        value: v
      }))
      const dataMap = _.keyBy(
        data.map((v, index) => ({
          ...v.value,
          date: v.date,
          split:
            this.dateRange !== "CYCLE_TIME_SIX_MONTHES" &&
            dayjs(v.date).day() === 1 &&
            index !== 0, // 六月线不分割
        })),
        "date"
      )

      console.log(_.maxBy(data, (o) => o.value.num))
      const interval = Math.floor(
        _.maxBy(data, (o) => o.value.num).value.num / 5
      )
      console.log('dayQtyLimit',dayQtyLimit)
      chartInstance.setOption({
        grid: {
          left: "120px",
          right: "100px",
          bottom: "100px",
          top: "20px"
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
          formatter: (data) => {
            let dataIndex = data[0].dataIndex
            if (this.dateRange === "CYCLE_TIME_FOUR_WEEKS") {
              let weekKey = [
                "lastThreeWeekAverageNumDto",
                "lastTwoWeekAverageNumDto",
                "lastWeekAverageNumDto",
                "currentWeekAverageNumDto",
              ]
              if (todayWeekDay !== 0) {
                weekKey.unshift("")
              }
              let curWeekIndex = Math.floor((dataIndex + todayWeekDay) / 7)
              const key = weekKey[curWeekIndex]
              const curWeek = resp[key]
              if (curWeek) {
                const {
                  lowPeakWeekAverageNum,
                  peakDayWeekAverageNum,
                  weekAverageNum,
                } = curWeek
                return [
                  `周平均箱量: ${weekAverageNum}<br/>`,
                  `周旺时平均箱量: ${peakDayWeekAverageNum}<br/>`,
                  `周淡时平均箱量: ${lowPeakWeekAverageNum}<br/>`,
                  `平均日箱量: ${data[1].data}`
                ].join("")
              } else {
                return [
                `时间: ${data[0].name}<br/>`,`箱量: ${data[0].value}<br/>`,`平均日箱量: ${data[1].data}`
                ].join("")
              }
            } else {
              return [
                `时间: ${data[0].name}<br/>`,`箱量: ${data[0].value}<br/>`,`平均日箱量: ${data[1].data}`
              ].join("")
            }
          },
        },
        xAxis: {
          type: "category",
          data: data.map((v) => v.date),
          axisLabel: {
            interval: 0,
            // tip, 带了拖动的话, index 并不是固定的, 所以从 map 中根据时间取值
            // rotate: -45,
            formatter: (value, index) => {
              const date = dayjs(value)
              const dataItem = dataMap[value]
              let res = []
              // 四周数据逻辑
              if (this.dateRange === "CYCLE_TIME_FOUR_WEEKS") {
                res.push(`{b|${date.format("MM/DD")}}`)
                res.push(`{b|${WEEK_DAY[date.day()]}}`)
                if (dataItem.festival) {
                  let text = `{tag|节}`
                  res.push(text)
                }
              } else {
                // 三月和六月的数据
                let temp = []
                // 周一
                if (date.day() === 1) {
                  temp = []
                  temp.push(`{text|${date.format("MM/DD")}}`)
                  temp.push(`{text|${WEEK_DAY[date.day()]}}`)
                }
                res.push(...temp)
              }

              // 节假日, 周几标注
              return res.join("\n")
            },
            rich: {
              b: {
                padding: 4,
                fontSize: 10,
              },
              c: {
                padding: [2, 4],
                align: "center",
                fontSize: 10,
              },
              text: {
                padding: 4,
                fontSize: 10,
              },
              tag: {
                backgroundColor: "#ff9100",
                color: "#fff",
                padding: [1, 2],
                fontSize: 11,
              },
            },
          },
          maxInterval: 1,
          minInterval: 1,
          splitLine: {
            show: true,
            interval(_, v) {
              return dataMap[v].split
            },
            lineStyle: {
              color: "#5c9bd1",
              type: "dotted",
            },
          },
          axisLine: {},
          axisTick: {
            show: false,
          },
        },
        yAxis: {
          type: "value",
          show: this.isFourWeekRange ? false : true,
          max: function (value) {
            let max = dayQtyLimit  > value.max ? dayQtyLimit : value.max
            const remain = max % interval
            return remain ? max + (interval - remain) : max
          },
          min: 0,
          minInterval: 1,
          interval: interval,
          // splitNumber:
        },
        series: [
          {
            type: "bar",
            barWidth: "30%",
            data: data.map((v) => v.value.num),
            label: {
              show: true,
              position: "top",
              formatter: (v) => {
                const dataItem = dataMap[v.name]
                const isToday = dayjs().isSame(dataItem.date, "day")
                if (this.isFourWeekRange) {
                  if (isToday) {
                    return [`{orange|今天}`, `{value|${v.value}}`].join("\n")
                  }
                  return v.value
                } else {
                  return isToday
                    ? "今天"
                    : `{orange|${dataItem.nationalHoliday}}`
                }
              },
              rich: {
                orange: {
                  color: "#ff9100",
                  fontSize: 12,
                  padding: 4,
                },
                value: {
                  align: "center",
                  textAlign: "center",
                  fontSize: 12,
                },
              },
            },
            markLine: {
              silent: true,
              symbol: ["none", "none"],
              lineStyle: {
                type: "solid",
              },
              data: [
                // {
                //   yAxis: averageNum,
                //   lineStyle: {
                //     color: COLOR_THEME[0],
                //     lineHeight: 1.4,
                //   },
                //   label: {
                //     formatter: () => `平均日箱量: ${averageNum}`,
                //   },
                // },
                {
                  xAxis: today,
                  lineStyle: {
                    color: "#fd7d2a",
                    type: "dotted",
                    opacity: 0,
                  },
                  label: {
                    formatter: () => {
                      // return  this.isFourWeekRange ? "今天" : ""
                      return ""
                    },
                  },
                },
                // {
                //   yAxis: dayQtyLimit,
                //   lineStyle: {
                //     color: dayQtyLimit || dayQtyLimit == 0?"#f00":"#fff",
                //     lineHeight: 1.4,
                //     opacity:dayQtyLimit || dayQtyLimit == 0?1:0
                //   },
                //   label: {
                //     position: 'start',
                //     distance:['30',0],
                //     formatter: () => dayQtyLimit || dayQtyLimit == 0?`每日箱量额度: ${dayQtyLimit}`:null,
                //   },
                // },
              ],
            },

            itemStyle: {
              color: ({ dataIndex }) => {
                const dataItem = data[dataIndex]
                if (this.isFourWeekRange) {
                  return [
                    dataItem.value.peakDay,
                    dataItem.value.nationalHoliday,
                  ].some(Boolean)
                    ? COLOR_THEME[1]
                    : COLOR_THEME[0]
                } else {
                  if (dataItem.value.nationalHoliday) {
                    return COLOR_THEME[0]
                  }
                  if (dataItem.value.peakDay) {
                    return COLOR_THEME[1]
                  }
                  return COLOR_THEME[0]
                }
              },
            },
          },
          {
            type: 'line',
            smooth: true,
            data: data.map((v) => this.portIdList.length ? v.value.averageNum : 0),
            itemStyle : {  
              normal : {  
                lineStyle:{  
                  color:'#FF9003'  
                }  
              }  
            },  
          }
        ],
        dataZoom: [
          {
            show: true,
            zoomLock: false,
            start: 100 - chartDisplayPercent(),
            end: 100,
            labelFormatter(index) {
              return dayjs(data[index].date).format("MM/DD")
            },
            textStyle: {
              fontSize: 10,
            },
          },
        ],
      })
      return
    },
    genDateRange() {
      let num = 27
      let unit = "day"
      if (this.dateRange === "CYCLE_TIME_FOUR_WEEKS") {
        num = 28 - 1
        unit = "day"
      } else if (this.dateRange === "CYCLE_TIME_THREE_MONTHES") {
        num = 90 - 1
        unit = "day"
      } else if (this.dateRange === "CYCLE_TIME_SIX_MONTHES") {
        num = 180 - 1
        unit = "day"
      }
      const now = dayjs()
      const prevEndDate = now
      const prevStartDate = now.subtract(num, unit)
      const curWeekStartDate = now.add(1, "day")
      const curWeekEndDate = now.add(7, "day")
      return [
        prevStartDate,
        prevEndDate,
        curWeekStartDate,
        curWeekEndDate,
      ].map((v) =>
        v
          .set("hour", 0)
          .set("minute", 0)
          .set("second", 0)
          .set("millisecond", 0)
          .format("YYYY-MM-DD")
      )
    },
    handleToggle() {
      this.isCollapsed = !this.isCollapsed
    },
    async addWatcher() {
      const [startDate, a, b, endDate] = this.genDateRange()
      const datePayload = {
        startDate,
        endDate,
      }
      await fetchContainerPortAndNum(datePayload).then(async (data) => {
        // 使用默认提供的选项
        this.$watch("portOptionList", {
          immediate: true,
          handler(val) {
            if (val.length) {
              this.portList = val
            }
          },
        })
        // await delay(800)
        this.portList = _.unionBy(data, this.portOptionList, 'portId')
        console.log('=====>',this.portList)
        if (data.length) {
          if (Array.isArray(this.defaultPortIds) && this.defaultPortIds.length) {
            this.portIdList = _.cloneDeep(this.defaultPortIds)
          } else {
            this.portIdList.push(this.portList[0].portId)
          }
        }
        const payload = {
          ...datePayload,
          portIds: [...new Set(this.portIdList)],
          cycleTime: this.dateRange,
        }
        this.$watch("portIdList", {
          immediate: true,
          handler(val) {
            const [startDate, _, __, endDate] = this.genDateRange()
            this.renderChart({
              ...payload,
              startDate,
              endDate,
              cycleTime: this.dateRange,
            })
          },
        })
        this.$watch("dateRange", {
          handler: (val) => {
            this.changePortSection()
            // const [startDate, _, __, endDate] = this.genDateRange()
            // this.renderChart({
            //   ...payload,
            //   cycleTime: this.dateRange,
            //   startDate,
            //   endDate,
            // })
          },
        })
        this.$watch("defaultPortIds", {
          handler(val) {
            if (
              Array.isArray(this.defaultPortIds) &&
              this.defaultPortIds.length
            ) {
              this.portIdList = _.cloneDeep(this.defaultPortIds)
            }
          },
        })
        console.log('===portList==>',this.portList)
      })
    },
    changePortSection() {
      const [startDate, a, b, endDate] = this.genDateRange()
      const datePayload = {
        startDate,
        endDate,
      }
      changeTime(datePayload).then(data => {
        this.portList = _.unionBy(data, this.portOptionList, 'portId')
        if (data.length) {
          if (Array.isArray(this.defaultPortIds) && this.defaultPortIds.length) {
            this.portIdList = _.cloneDeep(this.defaultPortIds)
          } else {
            this.portIdList.push(this.portList[0].portId)
          }
        }
        const payload = {
          ...datePayload,
          portIds: [...new Set(this.portIdList)],
          cycleTime: this.dateRange,
        }
        this.renderChart({
          ...payload,
          cycleTime: this.dateRange,
          // startDate: datePayload.startDate,
          // endDate: datePayload.endDate
        })
      })
    }
  },
  computed: {
    disableCheckbox() {
      return this.portIdList.length <= 1
    },
    isFourWeekRange() {
      return this.dateRange === "CYCLE_TIME_FOUR_WEEKS"
    },
  },
  beforeDestroy() {
    chartInstance = null
  },
}
</script>

<style lang="less">
.container-balance {
  .section-header {
    // text-align: right;
    display: flex;
    justify-content: space-between;
    > span {
      font-size: 18px;
      display: inline-block;
      margin-right: 10px;
    }
    > i {
      cursor: pointer;
    }
  }
  .port-form {
    display: flex;
    align-items: center;
    font-size: 14px;
    justify-content: space-between;
    display: inline-block;
    > div {
      display: inline-flex;
    }
    .form-label {
      margin-right: 14px;
    }
    .ivu-checkbox-wrapper {
      font-size: 14px;
    }
  }
  .chart-box {
    font-size: 14px;
    font-weight: 600;
    position: relative;
    #container-balance-chart {
      height: 360px;
    }
    > span {
      position: absolute;
      top: 0;
      &:nth-of-type(1) {
        left: 0;
      }
      &:nth-of-type(2) {
        right: 16px;
      }
    }
  }
  .checkbox {
    transform: translate(-50%, 0px);
    position: absolute;
    left: 50%;
    top: 20px;
    width: 100%;
    text-align: center;
  }
  .legend {
    display: inline-block;
    vertical-align: middle;
    font-size: 14px;
    .legend-item {
      display: inline-flex;
      align-items: center;
      margin-left: 20px;
      &:first-of-type {
        margin-left: 0px;
      }
    }
    .color-area {
      display: inline-block;
      width: 30px;
      height: 14px;
      border-radius: 4px;
      margin-right: 6px;
    }
  }
}
.dateRange-select {
  position: absolute;
  display: inline-block;
  right: 80px;
  font-size: 14px;
}
.rectangle {
  display: inline-block;
  width: 10px;
  height: 10px;
  background: #f09537;
  margin-right: 4px;
}
.text-red {
    color: red;
  }
.text-green {
  color: #6be6c1;
}

.ivu-card.ivu-card-bordered{
  overflow: auto;
}
</style>



// WEBPACK FOOTER //
// container-balance-chart.vue?2d724b5e